








import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import PopupExample, { PopupParams } from "./PopupExample.vue";

@Component({
})

export default class SelectButton extends Vue {
    @Prop({ default: false }) isActive: boolean;
    @Prop({ default: false }) unclickable: boolean;
    @Prop({ default: true }) needHover: boolean;

    @Prop() errorText: string | undefined;
    @Prop() title: string | undefined;

    popup: PopupExample | null = null;

    mounted() {
        this.initPopup();
    }

    @Watch('errorText')
    @Watch('title')
    initPopup() {
        if (this.errorText || this.title) {
            this.$el.addEventListener('mouseenter', this.shopPopup);
            this.$el.addEventListener('mouseleave', this.hidePopup);
        }
    }

    shopPopup() {
        if(!this.popup) {
            this.createPopup()
        }

        this.popup?.show();
    }

    hidePopup() {
        this.popup?.hide();
    }

    createPopup() {
        const text = this.errorText || this.title;

        if(text) {
            const children = this.$el.children;
            const $reference = children.namedItem('button');

            const params: PopupParams = {
                text: text,
                isError: Boolean(this.errorText),
                maxWidth: 190
            }

            const example = this.popup = new PopupExample({ propsData: { refElement: $reference, params } });
            example.$mount(document.body.appendChild(document.createElement('div')));
        }
    }

    destroyPopup() {
        this.popup?.$destroy();
        this.popup = null;
    }

    beforeDestroy() {
        this.$el.removeEventListener('mouseenter', this.shopPopup);
        this.$el.removeEventListener('mouseleave', this.hidePopup);

        this.destroyPopup();
    }

    get $s() {
        return this.$style
    }

    get classes() {
        return {
            [this.$s.active]: this.isActive,
            [this.$s.unclickable]: this.unclickable,
            [this.$s.hoverAllowed]: this.needHover,
            [this.$s.selectButton]: true,
            [this.$s.blankButton]: true
        }
    }
}

